import competitionFinancesCreate from '@/store/modules/competition-finances/competition-finances-create'
import competitionFinancesEdit from '@/store/modules/competition-finances/competition-finances-edit'
import competitionFinancesGet from '@/store/modules/competition-finances/competition-finances-get'

export default {
  competitionFinancesCreate,
  competitionFinancesEdit,
  competitionFinancesGet,
}
